import { atomWithReset } from 'jotai/utils';

import { OrganizationNotificationDrawer } from './types';

export const organizationNotificationDrawerState = atomWithReset<OrganizationNotificationDrawer>({
  page: 1,
  perPage: 6,
  totalPage: 1,
  totalCount: 0,
});
